import { PagedResponse, QueryParams } from "../types";

const DEFAULT_PAGE_SIZE = 25;

export class LocalLookupService<
  T extends { id: number | string | boolean | null; label: string; [key: string]: any }
> {
  private data: T[];

  constructor(data: T[]) {
    this.data = data;
  }

  public async getAll(params?: QueryParams): Promise<T[]> {
    if (!params) {
      return this.data;
    }

    const {token, ...searchParams} = params;
    return this.data.filter(item => Object.keys(searchParams).every(key => item[key] === params[key]));
  }

  public async search(params: QueryParams): Promise<PagedResponse<T>> {
    const filteredData = this.filterData(params);
    const filterAndPagedData = this.pageData(filteredData, params);
    return filterAndPagedData;
  }

  public async get(id: string): Promise<T | undefined> {
    return this.data.find((item) => item["id"] === id);
  }

  protected filterData({ query }: { query?: string }): T[] {
    return query
      ? this.data.filter(
          (item) => item.label.toLowerCase().indexOf(query) !== -1
        )
      : this.data;
  }

  private pageData(baseData: T[], { page }: QueryParams): PagedResponse<T> {
    const totalCount = baseData.length;

    return page !== undefined
      ? {
          data: baseData.slice(
            page * DEFAULT_PAGE_SIZE,
            page * DEFAULT_PAGE_SIZE + DEFAULT_PAGE_SIZE
          ),
          count: totalCount,
          page,
          pageSize: DEFAULT_PAGE_SIZE,
        }
      : {
          data: baseData,
          count: totalCount,
          pageSize: baseData.length,
          page: 0,
        };
  }
}
